import { StyleSheet } from 'aphrodite/no-important';
import { spacers, palettes } from '@trainline/depot-web/css';

export default StyleSheet.create({
  container: {
    border: `1px solid ${palettes.dp_app_border_base}`,
    borderRadius: `${spacers.dp_s8} ${spacers.dp_s8}`,
    background: palettes.dp_app_backdrop_white,
    padding: `${spacers.dp_s12} 0`,
    flex: 1,
  },
  transactionsSection: {
    padding: `0 ${spacers.dp_s8}`,
  },
  transactionContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: `${spacers.dp_s4} 0`,
  },
  transaction: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    gap: spacers.dp_s8,
  },
  amount: {
    fontWeight: 'bold',
  },
  failed: {
    color: palettes.dp_app_text_negative,
  },
  warning: {
    marginBottom: spacers.dp_s16,
  },
  total: {
    marginTop: spacers.dp_s16,
    borderTop: `1px solid ${palettes.dp_app_border_base}`,
    padding: `${spacers.dp_s16} ${spacers.dp_s8} 0`,
    display: 'flex',
    justifyContent: 'space-between',
  },
  subduedText: {
    color: palettes.dp_app_text_subdued,
  },
});
